import { ICON_CHEVRON_DIRECTION } from '../Icon'

export const NAV_ARROWS_DIRECTIONS = Object.values(ICON_CHEVRON_DIRECTION)
